import { ServiceFetch } from '../service-fetch'

export default class ProductZoneModel extends ServiceFetch {
    getProductZoneBy = (data) => this.authFetch({
        url: 'product-zone/getProductZoneBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}